import {List, ListItem, ListItemIcon, ListItemText} from "@mui/material";
import {Box} from "@mui/system";
import {MaterialSymbol} from "react-material-symbols";
import {SymbolCodepoints} from "react-material-symbols/dist/types";
import {BORDER_RADIUS_INNER} from "../../../../config/themes/theme";

interface ListViewModel {
  id: string;
  leadingIcon: SymbolCodepoints;
  title: string;
  subtitle?: string;
}

interface SuggestionListUIProps {
  suggestionItems: (ListViewModel & {value: string})[];
  onSuggestionItemClick: (value: string) => void;
}

export default function SuggestionListUI({
  suggestionItems,
  onSuggestionItemClick,
}: SuggestionListUIProps) {
  return (
    <List sx={{width: "100%", display: "grid", gap: 0.25}}>
      {suggestionItems.map((item, idx) => {
        const itemsSize = suggestionItems.length;
        return (
          <ListItem
            key={item.id}
            onClick={() => onSuggestionItemClick(item.value)}
            sx={{
              bgcolor: "secondary.light",
              borderTopLeftRadius: idx === 0 ? BORDER_RADIUS_INNER : 4,
              borderTopRightRadius: idx === 0 ? BORDER_RADIUS_INNER : 4,
              borderBottomLeftRadius:
                idx === itemsSize - 1 ? BORDER_RADIUS_INNER : 4,
              borderBottomRightRadius:
                idx === itemsSize - 1 ? BORDER_RADIUS_INNER : 4,
              p: 1,
              pl: 2,
              cursor: "pointer",
              "&:hover": {
                bgcolor: "secondary.main",
              },
            }}>
            <ListItemIcon sx={{mr: -1}}>
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: "white",
                  borderRadius: "8px",
                  color: "primary.contrastText",
                }}>
                <MaterialSymbol
                  icon={item.leadingIcon as SymbolCodepoints}
                  size={24}
                  weight={300}
                />
              </Box>
            </ListItemIcon>
            <ListItemText
              primary={item.title}
              secondary={item.subtitle}
              primaryTypographyProps={{
                fontWeight: 600,
                fontSize: "0.875rem",
              }}
              secondaryTypographyProps={{
                fontWeight: 500,
                fontSize: "0.75rem",
              }}
            />
          </ListItem>
        );
      })}
    </List>
  );
}
